import { InphiniteThemeProvider, ToastProvider } from '@facephi/ui-react';
import { RecoilRoot } from 'recoil';
import {
  AuthProvider,
  TranslationProvider,
  GlobalProvider,
  FacialProvider,
  VocalProvider,
  TransferProvider,
  DataProvider,
  ConfigProvier,
} from './providers';
import { Routes } from './routes/Routes';
import { GlobalStyles, SelphiDemoTheme } from './styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sseUrl = (window as any)._env_.REACT_APP_DEMO_BACKEND;

export const App = () => {
  return (
    <InphiniteThemeProvider customTheme={SelphiDemoTheme}>
      <GlobalStyles />
      <GlobalProvider>
        <TranslationProvider>
          <ToastProvider>
            <RecoilRoot>
              <AuthProvider>
                <DataProvider url={sseUrl}>
                  <FacialProvider>
                    <VocalProvider>
                      <ConfigProvier>
                        <TransferProvider>
                          <Routes />
                        </TransferProvider>
                      </ConfigProvier>
                    </VocalProvider>
                  </FacialProvider>
                </DataProvider>
              </AuthProvider>
            </RecoilRoot>
          </ToastProvider>
        </TranslationProvider>
      </GlobalProvider>
    </InphiniteThemeProvider>
  );
};
